import { useState, useCallback } from 'react'
import { genId } from '../lib/uuid'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: string
  type: ToastType
  message: string
  duration?: number
}

// 전역 toast 관리 — 단순 useState 기반 (zustand 사용 안 하는 이유: toast는 순간적)
let toastListeners: Array<(toasts: Toast[]) => void> = []
let toastList: Toast[] = []

function notify() {
  toastListeners.forEach((fn) => fn([...toastList]))
}

export const toast = {
  show(type: ToastType, message: string, duration = 3500) {
    const id = genId()
    toastList = [...toastList, { id, type, message, duration }]
    notify()
    setTimeout(() => {
      toastList = toastList.filter((t) => t.id !== id)
      notify()
    }, duration)
  },
  success: (msg: string) => toast.show('success', msg),
  error: (msg: string) => toast.show('error', msg, 5000),
  warning: (msg: string) => toast.show('warning', msg),
  info: (msg: string) => toast.show('info', msg),
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([])

  const subscribe = useCallback(() => {
    toastListeners.push(setToasts)
    return () => {
      toastListeners = toastListeners.filter((fn) => fn !== setToasts)
    }
  }, [])

  const dismiss = useCallback((id: string) => {
    toastList = toastList.filter((t) => t.id !== id)
    notify()
  }, [])

  return { toasts, subscribe, dismiss }
}
